import { PlainItemsSelector } from 'app/common/ui-next/plain-selector'
import { OrgId } from 'app/common/types/id'

import {
  filterActions,
  useFilterOptionsLoadingByKey,
  useFilterOptions,
  useFilter,
} from '../../filterStore'

import { sortByTitle, emptyArray } from './helpers'

export const OrgControl = () => {
  const ids = useFilter('orgIds')
  const orgs = useFilterOptions('orgs')
  const loading = useFilterOptionsLoadingByKey('orgs')

  return (
    <PlainItemsSelector
      id="org"
      label="Заведение"
      header="Выбор заведений"
      pleaseSelectText="Все"
      items={orgs}
      selection={ids.draft || emptyArray}
      defaultSelection={ids.default || emptyArray}
      onChange={(selected) => filterActions.selectDraftOrgIds(selected as Array<OrgId> | undefined)}
      loading={loading}
      sortFunc={sortByTitle}
      skipUpperSpace
      multiple
    />
  )
}
